// src/auth/RequireAuth.tsx
//
// Route guard for authenticated-only routes. Use as a layout route element:
//
//   <Route element={<RequireAuth />}>
//     <Route element={<AppLayout />}>
//       ...protected routes...
//     </Route>
//   </Route>
//
// While Firebase resolves the session we render a neutral placeholder so we
// never flash a redirect for an already-logged-in user on a hard refresh.
// When logged out we redirect to /login and stash the attempted location in
// router state, so LoginPage can send the user back where they were headed.

import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuthUser } from '../useAuthUser';
import styles from './RequireAuth.module.scss';

const RequireAuth = () => {
	const { user, loading } = useAuthUser();
	const location = useLocation();

	if (loading) {
		return (
			<div className={styles.gate}>
				<div
					className={styles.spinner}
					aria-hidden='true'
				/>
				<span className={styles.label}>Loading…</span>
			</div>
		);
	}

	if (!user) {
		return (
			<Navigate
				to='/login'
				replace
				state={{ from: location }}
			/>
		);
	}

	return <Outlet />;
};

export default RequireAuth;
